import Inputmask from 'inputmask';

export function pcCycleDocumentRegister() {
  const $pcCycleDocumentForm = $('.pc-cycle-document-form');
  if (!$pcCycleDocumentForm || $pcCycleDocumentForm.length === 0) return;

  $('.form-field-radio [name="change-surname"]').on('change', (e) => {
    const $t = $(e.currentTarget);

    if ($t.prop('checked') && $t.val() === 'true') {
      $('.pc-cycle-document-form-change-surname').addClass('show');
    } else {
      $('.pc-cycle-document-form-change-surname').removeClass('show');
    }
  });

  if ($('input[name="citizen-rf"]').length) {
    setPassportMasks();
  }

  $('input[name="citizen-rf"]').on('change', function () {
    setPassportMasks();
  });
}

function setPassportMasks() {
  console.log($('input[name="citizen-rf"]:checked').val());
  if ($('input[name="citizen-rf"]:checked').val() == 1) {
    new Inputmask('99 99').mask($('input[placeholder="Серия"]').get(0));
    new Inputmask('999999').mask($('input[placeholder="Номер"]').get(0));
    new Inputmask('999-999').mask(
      $('input[placeholder="Код подразделения"]').get(0)
    );
  } else {
    Inputmask.remove($('input[placeholder="Серия"]').get(0));
    Inputmask.remove($('input[placeholder="Номер"]').get(0));
    Inputmask.remove($('input[placeholder="Код подразделения"]').get(0));
  }
}
